import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';

import { companyProfileSettings } from '../actions/settings_companyProfile.action';
import { kinetik_api_url } from '../utilities/const';
import WindowAlert from '../common/AlertComponent';

var jwtDecode = require('jwt-decode');

class CompanyProfile extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            company_name: '',
            company_zip: '',
            company_address: '',
            company_city: '',
            company_state: '',
            company_billing_id: '',
            company_billing_tax_id: '',
            company_billing_npi: '',
            company_billing_address: '',
            company_billing_city: '',
            company_billing_zip: '',
            company_billing_state: '',
            company_contact_phone: '',
            company_contact_email: '',
            company_contact_website: '',
            dataApeended: false,
            isInfoUpdated: false,
            messageType: '',
            message: ''
        };

    }

    componentDidMount() {
        let userID = jwtDecode(localStorage.getItem('authToken')).user_id;
        let URL = kinetik_api_url + '/get_boarding_info/' + userID;
        axios.get(URL)
        .then( (response) => {
            let vals = response.data.result;
            this.setState({
                company_name: vals.company_name,
                company_zip: vals.company_zip,
                company_address: vals.company_address,
                company_city: vals.company_city,
                company_state: vals.company_state,
                company_billing_id: vals.company_billing_id,
                company_billing_tax_id: vals.company_billing_tax_id,
                company_billing_npi: vals.company_billing_npi,
                company_billing_address: vals.company_billing_address,
                company_billing_city: vals.company_billing_city,
                company_billing_zip: vals.company_billing_zip,
                company_billing_state: vals.company_billing_state,
                company_contact_phone: vals.company_contact_phone,
                company_contact_email: vals.company_contact_email,
                company_contact_website: vals.company_contact_website,
                dataApeended: true
            });
            
            // parse JSON for companybrokers, companypayers
            let processCompanyPayer = response.data.result.company_payers.length !== 0 ?
             JSON.parse(response.data.result.company_payers) : [];
            let processCompanyBroker = response.data.result.company_brokers.length !== 0 ?
             JSON.parse(response.data.result.company_brokers) : [];
            response.data.result.company_payers = processCompanyPayer;
            response.data.result.company_brokers = processCompanyBroker;

            this.props.companyProfileSettings(response.data.result);
        })
        .catch( (err) => {
            console.log(err);
        })
        
    }

    stateChangeHandler = (e) => {
        this.props.companyProfileSettings({
            [e.target.name]: e.target.value
        });
    }

    updateCompanyProfile = () => {
        // let userID = jwtDecode(localStorage.getItem('authToken')).user_id;
        let URL = kinetik_api_url + '/update_boarding_info';

        axios.put(URL, this.props.profileInfo)
        .then( (result) => {
            this.setState({
                messageType: result.data.status,
                message: result.data.message,
                isInfoUpdated: true
            });
        })
        .catch( (err) => {
            this.setState({
                messageType: "error",
                message: err.data.message,
                isInfoUpdated: true
            });
        })

    }

    handleAlert = () => {
        this.setState({
            isInfoUpdated: false
        })
    }
    
    render(){
        return (
            <div className="row">
                <div className="col-md-2"></div>
                <div className="col-md-8">
                    {this.state.dataApeended && 
                        <div className="brd_tab_cntnt settings_page_profile">
                            <div className="brding_frm_ele">
                                <span>Company Name</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_name} name="company_name" type="text" placeholder="Company Name" />
                            </div> <br />
                            <div className="brding_frm_ele">
                                <span>Address</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_address} name="company_address" type="text" placeholder="Address" />
                            </div> <br />

                            <div className="inline_making_attempt">
                                <div className="brding_frm_ele first_p_elel fx_zip_c_f">
                                    <span>City</span>
                                    <input onChange={this.stateChangeHandler} defaultValue={this.state.company_city} name="company_city" style={{ width: '18%' }} type="text" placeholder="City" />
                                </div>
                                <div className="brding_frm_ele last_p_elel fx_zip_c_l">
                                    <span>Zip Code</span>
                                    <input onChange={this.stateChangeHandler} defaultValue={this.state.company_zip} name="company_zip" type="text" placeholder="Zip Code" />
                                </div>
                            </div> <br />

                            <div className="brding_frm_ele">
                                <span>State</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_state} name="company_state" type="text" placeholder="State" />
                            </div> <br /> <br />

                            <b>Company billing info</b>

                            <div className="brding_frm_ele fx_margin">
                                <span>Billing ID</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_billing_id} name="company_billing_id" style={{ width: '23%' }} type="text" placeholder="Billing ID" />
                            </div> <br />
                            <div className="brding_frm_ele">
                                <span>Tax ID</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_billing_tax_id} name="company_billing_tax_id" style={{ width: '27%' }} type="text" placeholder="Tax ID" />
                            </div> <br />
                            <div className="brding_frm_ele">
                                <span>Billing NPI</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_billing_npi} name="company_billing_npi" style={{ width: '22%' }} type="text" placeholder="Billing NPI" />
                            </div> <br />
                            <div className="brding_frm_ele">
                                <span>Billing Address</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_billing_address} name="company_billing_address" type="text" placeholder="Billing Address" />
                            </div> <br />

                            <div className="inline_making_attempt">
                                <div className="brding_frm_ele first_p_elel fx_zip_c_f">
                                    <span>City</span>
                                    <input onChange={this.stateChangeHandler} defaultValue={this.state.company_billing_city} name="company_billing_city" style={{ width: '18%' }} type="text" placeholder="City" />
                                </div>
                                <div className="brding_frm_ele last_p_elel fx_zip_c_l">
                                    <span>Zip Code</span>
                                    <input onChange={this.stateChangeHandler} defaultValue={this.state.company_billing_zip} name="company_billing_zip" type="text" placeholder="Zip Code" />
                                </div>
                            </div> <br />

                            <div className="brding_frm_ele">
                                <span>State</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_billing_state} name="company_billing_state" type="text" placeholder="State" />
                            </div> <br /> <br />

                            <b>Company Contact</b>

                            <div className="brding_frm_ele fx_margin">
                                <span>Phone</span>
                                <input onChange={this.stateChangeHandler} defaultValue={this.state.company_contact_phone} name="company_contact_phone" style={{ width: '27%' }} type="text" placeholder="Phone" />
                            </div> <br />

                            <div className="inline_making_attempt">
                                <div className="brding_frm_ele first_p_elel">
                                    <span>Website</span>
                                    <input onChange={this.stateChangeHandler} defaultValue={this.state.company_contact_website} name="company_contact_website" style={{ width: '22%' }} type="text" placeholder="Website" />
                                </div> <br />
                                <div className="brding_frm_ele last_p_elel">
                                    <span>Email</span>
                                    <input onChange={this.stateChangeHandler} defaultValue={this.state.company_contact_email} name="company_contact_email" type="text" placeholder="Email" />
                                </div> <br /> <br />
                            </div> <br />

                            <div className="update_profile_btn">
                                <input onClick={this.updateCompanyProfile} type="submit" className="settings_update_btn" id="submit_box" value="UPDATE COMPANY PROFILE" />
                            </div>
                        </div>
                    }
                </div>
                <div className="col-md-2"></div>

                <WindowAlert
                    show={this.state.isInfoUpdated}
                    messageType={this.state.messageType}
                    text={this.state.message}
                    onCofirm={this.handleAlert}
                />
            </div>
        )
    }
};

CompanyProfile.propTypes = {
    profileInfo: PropTypes.object.isRequired,
    companyProfileSettings: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    profileInfo: state.settingsData
});

export default connect(mapStateToProps, {companyProfileSettings})(CompanyProfile);


// WEBPACK FOOTER //
// ./src/app/profile_settings/CompanyProfile.js